import { Navigate, useLocation } from 'react-router-dom';
import { checkLoggedIn } from '../functions/CookieHelper';

export const ProtectedRoute = ({ children }) => {
    const location = useLocation();

    if (!checkLoggedIn()) {
        return <Navigate to={`/login?returnPage=${encodeURIComponent(location.pathname + location.search)}`} replace />;
    }

    return children;
};
